//  公共接口
import { doGet, doPost } from '@/api/http'
let apis = '/electricity'

/**
 * 企业分页列表
 * @param {String} enterpriseName 企业名称
 * @param {String} orderByColumn 排序字段
 * @param {String} isAsc 排序是升序还是降序 只能填asc（升序）和desc（降序）
 * @param {Number} pageIndex 页码
 * @param {Number} pageSize 条数
 */
export async function getProjectList (params) {
  let result = await doGet(apis + '/core/enterpriseBase/list', params)
  return result
}

// 上传文件
export async function uploadImg (params) {
  let result = await doPost(apis + '/file/img', params)
  return result
}

// 模拟推送报警
export async function gatewayMessageEvent (params) {
  let result = await doPost('/electrical-device-mqtt-connect/mock/gatewayMessageEvent', params)
  return result
}

// 获取 能耗区域分页
export async function getRegionList (params) {
  let result = await doGet('/electricity/core/regionBase/list', params)
  return result
}

// 获取 能耗区域分页
export async function detectorDownMenu (params) {
  let result = await doGet('/electricity/core/detectorBase/detectorDownMenu', params)
  return result
}
